import { InventoryTransactionType } from "@/modules/warehouses/inventory-transactions/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/inventory-transactions"

export const fetchInventoryTransactions = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchInventoryTransaction = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const createInventoryTransaction = async (data?: InventoryTransactionType) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updateInventoryTransaction = async (id: string, data?: InventoryTransactionType) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deleteInventoryTransaction = async (data: InventoryTransactionType) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updateInventoryTransaction(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
